// extracted by mini-css-extract-plugin
module.exports = {"overlay":"VideoLightbox_overlay__MBNuh","close":"VideoLightbox_close__JEscr","frameWrapper":"VideoLightbox_frameWrapper__y2u_O","frame":"VideoLightbox_frame__2zdiN"};